export default __webpack_public_path__ + "static/image4-9743d625069404186442f21a858a65c7.png";